'use client';

import { createContext, type FC, type ReactNode, useContext } from 'react';

export enum FeatureFlag {
  FIRST_DROP_MODAL = 'first-drop-modal',
  NFT_FEATURES = 'nft-features',
  PARTNER_MARKETPLACES = 'partner-marketplaces',
  WORKSHOP_FORGE = 'workshop-forge',
  WORKSHOP_BURN = 'workshop-burn',
  WORKSHOP_STAKE = 'workshop-stake',
  WORKSHOP_LEADERBOARD = 'workshop-leaderboard',
  HOME_FINISHED_SALES = 'home-finished-sales',
}

interface FeatureFlagContext {
  featuresEnabled: string;
  isFeatureEnabled: (feature: FeatureFlag) => boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContext | undefined>(undefined);

interface FeatureFlagClientProviderProps {
  children: ReactNode;
  featuresEnabled: string;
}

const FeatureFlagClientProvider: FC<FeatureFlagClientProviderProps> = ({ children, featuresEnabled }) => {
  const isFeatureEnabled = (feature: FeatureFlag) => {
    const featureEnabled = featuresEnabled.split(',');
    return featureEnabled.includes(feature);
  };

  return (
    <FeatureFlagContext.Provider value={{ featuresEnabled, isFeatureEnabled }}>{children}</FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);
  if (context === undefined) {
    throw new Error('usePublicMode must be used within a PublicModeProvider');
  }
  return context;
};

export { FeatureFlagClientProvider };
